// src/services/auth.js

export const setToken = (token) => {
    localStorage.setItem("token", token);
  };
  
  export const getToken = () => {
    const token = localStorage.getItem("token");
    if (!token || token === "undefined" || token === "null") {
      localStorage.removeItem("token");
      return null;
    }
    return token;
  };

  export const logout = () => {
    localStorage.removeItem("token");
  }